module.exports = __webpack_public_path__ + "static/media/mn21.0d6ffe93.jpeg";